import { DataDRequest } from "../../../data/DRequest";
import { Entidad } from "../../../data/Entidad";
import { _SvAlumnoAgregarRepeticion, IAgregarRepeticionesExtraInfo } from "../../../data/modulo/MateriaV2";
import _L, { _HttpMsgV2 } from "../../../util/Labels";
import { _ModalInfoDataList } from "../../controlD3/ModalThings/ModalInfoDataList";
import { _ModalToAProccess } from "../../controlD3/ModalThings/ModalToAProccess";

type IAsignacionAlumnoMateria = Entidad.IAsignacionAlumnoMateria
type IAsignacion = Pick<IAsignacionAlumnoMateria, "IdAsignacion" | "FrecuenciaEval"> & {
    NombreMateria: string;
    StrGrupo: string;
    Criterio?: string
}

interface AgregarRepeticionArgs {
    idEscuela: number,
    asignaciones: IAsignacion[],
    successCallback: () => void
}

export function _AgregarRepeticionConfirm({ idEscuela, asignaciones, successCallback }: AgregarRepeticionArgs) {
    type ItemResponse = {
        asignacion: IAsignacion,
        successCode?: number,
        errorCode?: number,
        nuevoInfo?: IAgregarRepeticionesExtraInfo["Insertados"][number]
    }

    const REPETICIONES_REQUERIDAS = 1

    _ModalToAProccess({
        Title: _L("panelalumnomaterias.action_agregar_repeticion"),
        DrawContent: (content) => content.text(_L("panelalumnomaterias.agregar_rept_msg")),
        Modulo: Entidad.CModulo.PanelAlumnoMaterias,
        Action: Entidad.CAccionPermiso.Agregar,
        IdsEscuelas: [idEscuela],
        OnAccept: async (mt) => {
            const idsAsignaciones: number[] = []
            const asignacionesMap: Map<number, IAsignacion> = new Map()
            for (const asig of asignaciones) {
                idsAsignaciones.push(asig.IdAsignacion)
                asignacionesMap.set(asig.IdAsignacion, asig)
            }

            const res = await _SvAlumnoAgregarRepeticion(idsAsignaciones, REPETICIONES_REQUERIDAS)
            if (res.Resultado > 0) {
                successCallback()
            }

            const resInsertados = res.Insertados || []
            const resErrores = res.Errores || []
            const resumenList: ItemResponse[] = []

            for (const idAsignacion of idsAsignaciones) {
                let successCode: number | undefined = undefined
                let errorCode: number | undefined = undefined
                let nuevoInfo: ItemResponse["nuevoInfo"] = undefined

                if (resErrores.length) {
                    const resError = resErrores.find(r => r.IdAsignacion == idAsignacion)
                    if (resError) {
                        errorCode = resError.Error
                    }
                }
                if (resInsertados.length) {
                    const resNuevo = resInsertados.find(r => r.IdAsignacion == idAsignacion)
                    if (resNuevo && resNuevo.Insertados == REPETICIONES_REQUERIDAS) {
                        successCode = 1
                    }
                    else if (!errorCode) {
                        if (!resNuevo) {
                            errorCode = -1
                        } else {
                            successCode = 1.1 // Se registraron N
                            errorCode = -1.1 // Algunas repeticiones no fueron agregadas
                        }
                    } else if (resNuevo && errorCode == -4) {
                        successCode = 1.1 // Se registraron N
                        errorCode = -4.1 // Algunas repeticiones no fueron agregadas, fuera del ciclo escolar
                    }
                }
                if (!errorCode && (res.Resultado <= 0 || !resInsertados.length)) {
                    errorCode = -1
                }
                const asignacion = asignacionesMap.get(idAsignacion)
                resumenList.push({
                    asignacion,
                    successCode,
                    errorCode,
                    nuevoInfo
                })
            }

            mt.Modal._Ocultar()

            _ModalInfoDataList({
                Title: _L("general.resumen"),
                DataList: resumenList,
                InfoText: null,
                OnStepItemData: (content, resumenItem) => {
                    // const res = resumenItem.successCode
                    const asignacion = resumenItem.asignacion
                    let html = `${asignacion.StrGrupo} | ${asignacion.NombreMateria}${asignacion.Criterio ? " | " + asignacion.Criterio : ""}`
                    // html += `${UIUtilTime._DateFormatStandar(itemData.Asignacion.Inicio)} - ${UIUtilTime._DateFormatStandar(itemData.Asignacion.Fin)}`

                    if (resumenItem.successCode !== undefined) {
                        const successMessageHttp = _HttpMsgV2({ ...res, Resultado: resumenItem.successCode }, "agregar")
                        if (resumenItem.successCode == 1.1)
                            successMessageHttp.replace("__", resumenItem.nuevoInfo?.Insertados + "" || "")
                        html += `<br><i style="color: var(--color_app_green1);">${successMessageHttp}.</i>`
                    }
                    if (resumenItem.errorCode !== undefined) {
                        const errorMessageHttp = _HttpMsgV2({ ...res, Resultado: resumenItem.errorCode }, "agregar")
                        html += `<br><i style="color: var(--color_app_red1);">${errorMessageHttp}.</i>`
                    }
                    content.html(html)
                }
            })

            return null
        }
    })
}